<script>
  export let product
  export let value
  export let selectedProduct
  export let selectedOption
  function toggleButton(option_type, option_value) {
    if (option_value == option_type) {
      selectedOption = null
    } else {
      selectedOption = option_value
    }
  }
</script>

<li
  class="option"
  productSelected={product.id == selectedProduct.id}
  selected={value == selectedOption}
>
  <div
    class="checkbox-wrapper"
    on:click={() => toggleButton(selectedOption, value)}
    on:keypress={() => toggleButton(selectedOption, value)}
    role="button"
    tabindex="0"
  >
    <div class="styled-checkbox" />
    <span>{value.presentation}</span>
  </div>
</li>
